module.exports = __webpack_public_path__ + "img/Profil_CS-Litevolumen_Standard-110.7dcf33e7.jpg";